import { Route, Routes } from 'react-router-dom'
import { Mobile, Pc } from './hooks/MediaQuery'
import HeaderPc from './components/HeaderPc'
import HeaderMobile from './components/HeaderMobile'
import BottomBarPc from './components/BottomBarPc'
import BottomBarMobile from './components/BottomBarMobile'
import Page1 from './pages/Page1/Page1'
import Page2 from './pages/Page2/Page2'
import Page3 from './pages/Page3/Page3'
import Page4 from './pages/Page4/Page4'
import Page5 from './pages/Page5/Page5'
import Page6 from './pages/Page6/Page6'
import PageCatalog from './pages/PageCatalog/PageCatalog'
import Page7 from './pages/Page7/Page7'
import Page0 from './pages/Page0/Page0'
import NavbarLayout from './NavbarLayout'
import React, { useEffect } from 'react'
import { selectCategory } from './modules/category'
import { useSelector, useDispatch } from 'react-redux'

import './styles/transition.css'
function App() {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(selectCategory())
  }, [])

  return (
    <>
      <Routes>
        <Route element={<NavbarLayout />}>
          <Route name="MAIN" path="/main" element={<Page0 />} />
          <Route name="MAIN" path="/" element={<Page0 />} />
          <Route name="HOME" path="/home" element={<Page1 />} />
          <Route name="CATEGORY" path="/category/:id" element={<Page2 />} />
          <Route name="GOODS" path="/goods/:id" element={<Page3 />} />
          <Route name="ITEM" path="/item/:gsId/:itemId" element={<Page4 />} />
          <Route name="CASE" path="/case/:id" element={<Page5 />} />
          <Route name="SOLOMON" path="/catalog" element={<Page6 />} />
          <Route name="CATALOG" path="/digital-catalog" element={<PageCatalog />} />
          <Route name="LOCATION" path="/location" element={<Page7 />} />
        </Route>
      </Routes>
    </>
  )
}

export default App
